import React, { useState } from 'react';
import "./IconPicker.css"

// Icon Data - Nur Handdrawn Icons (Animationen komplett entfernt)
const iconData = [
  { id: 'icon112', src: '/img/gif/clean/stop.gif', alt: 'Stop', style: 'Animations' },
  { id: 'icon113', src: '/img/gif/clean/stop2.gif', alt: 'Stop2', style: 'Animations' },
  { id: 'icon114', src: '/img/gif/clean/party.gif', alt: 'Party', style: 'Animations' },
  { id: 'icon115', src: '/img/gif/clean/football.gif', alt: 'Football', style: 'Animations' },
  { id: 'icon116', src: '/img/gif/clean/hookah.gif', alt: 'Hookah', style: 'Animations' },
  { id: 'icon117', src: '/img/gif/clean/vip3.gif', alt: 'Vip3', style: 'Animations' },
  { id: 'icon118', src: '/img/gif/clean/partycrasher.gif', alt: 'Partycrasher', style: 'Animations' },
  { id: 'icon119', src: '/img/gif/clean/award.gif', alt: 'Award', style: 'Animations' },
  { id: 'icon120', src: '/img/gif/clean/pyramids.gif', alt: 'Pyramids', style: 'Animations' },
  { id: 'icon121', src: '/img/gif/clean/boat.gif', alt: 'Boat', style: 'Animations' },
  { id: 'icon122', src: '/img/gif/clean/ocean.gif', alt: 'Ocean', style: 'Animations' },
  { id: 'icon123', src: '/img/gif/clean/fish.gif', alt: 'Fish', style: 'Animations' },
  { id: 'icon124', src: '/img/gif/clean/lobster.gif', alt: 'Lobster', style: 'Animations' },
  { id: 'icon125', src: '/img/icons/handdrawn/accept.svg', alt: 'Accept', style: 'Handdrawn' },
  { id: 'icon126', src: '/img/icons/handdrawn/animals.svg', alt: 'Animals', style: 'Handdrawn' },
  { id: 'icon127', src: '/img/icons/handdrawn/basketball.svg', alt: 'Basketball', style: 'Handdrawn' },
  { id: 'icon128', src: '/img/icons/handdrawn/beach-ball.svg', alt: 'Beach-Ball', style: 'Handdrawn' },
  { id: 'icon129', src: '/img/icons/handdrawn/beach-chair.svg', alt: 'Beach-Chair', style: 'Handdrawn' },
  { id: 'icon130', src: '/img/icons/handdrawn/beach.svg', alt: 'Beach', style: 'Handdrawn' },
  { id: 'icon131', src: '/img/icons/handdrawn/bed1.svg', alt: 'Bed1', style: 'Handdrawn' },
  { id: 'icon132', src: '/img/icons/handdrawn/bunk-bed.svg', alt: 'Bunk-Bed', style: 'Handdrawn' },
  { id: 'icon133', src: '/img/icons/handdrawn/cactus.svg', alt: 'Cactus', style: 'Handdrawn' },
  { id: 'icon134', src: '/img/icons/handdrawn/calendar1.svg', alt: 'Calendar1', style: 'Handdrawn' },
  { id: 'icon135', src: '/img/icons/handdrawn/camera.svg', alt: 'Camera', style: 'Handdrawn' },
  { id: 'icon136', src: '/img/icons/handdrawn/camping.svg', alt: 'Camping', style: 'Handdrawn' },
  { id: 'icon137', src: '/img/icons/handdrawn/cat.svg', alt: 'Cat', style: 'Handdrawn' },
  { id: 'icon138', src: '/img/icons/handdrawn/coconut-drink.svg', alt: 'Coconut-Drink', style: 'Handdrawn' },
  { id: 'icon139', src: '/img/icons/handdrawn/colosseum.svg', alt: 'Colosseum', style: 'Handdrawn' },
  { id: 'icon140', src: '/img/icons/handdrawn/couple.svg', alt: 'Couple', style: 'Handdrawn' },
  { id: 'icon141', src: '/img/icons/handdrawn/cover.svg', alt: 'Cover', style: 'Handdrawn' },
  { id: 'icon142', src: '/img/icons/handdrawn/cycling.svg', alt: 'Cycling', style: 'Handdrawn' },
  { id: 'icon143', src: '/img/icons/handdrawn/diamond.svg', alt: 'Diamond', style: 'Handdrawn' },
  { id: 'icon144', src: '/img/icons/handdrawn/diving.svg', alt: 'Diving', style: 'Handdrawn' },
  { id: 'icon145', src: '/img/icons/handdrawn/dog.svg', alt: 'Dog', style: 'Handdrawn' },
  { id: 'icon146', src: '/img/icons/handdrawn/double-click.svg', alt: 'Double-Click', style: 'Handdrawn' },
  { id: 'icon147', src: '/img/icons/handdrawn/drink.svg', alt: 'Drink', style: 'Handdrawn' },
  { id: 'icon148', src: '/img/icons/handdrawn/fan.svg', alt: 'Fan', style: 'Handdrawn' },
  { id: 'icon149', src: '/img/icons/handdrawn/feather.svg', alt: 'Feather', style: 'Handdrawn' },
  { id: 'icon150', src: '/img/icons/handdrawn/field.svg', alt: 'Field', style: 'Handdrawn' },
  { id: 'icon151', src: '/img/icons/handdrawn/flip-flops.svg', alt: 'Flip-Flops', style: 'Handdrawn' },
  { id: 'icon152', src: '/img/icons/handdrawn/football.svg', alt: 'Football', style: 'Handdrawn' },
  { id: 'icon153', src: '/img/icons/handdrawn/fridge.svg', alt: 'Fridge', style: 'Handdrawn' },
  { id: 'icon154', src: '/img/icons/handdrawn/gift.svg', alt: 'Gift', style: 'Handdrawn' },
  { id: 'icon155', src: '/img/icons/handdrawn/giraffe.svg', alt: 'Giraffe', style: 'Handdrawn' },
  { id: 'icon156', src: '/img/icons/handdrawn/glasses.svg', alt: 'Glasses', style: 'Handdrawn' },
  { id: 'icon157', src: '/img/icons/handdrawn/golf-club.svg', alt: 'Golf-Club', style: 'Handdrawn' },
  { id: 'icon158', src: '/img/icons/handdrawn/internet.svg', alt: 'Internet', style: 'Handdrawn' },
  { id: 'icon159', src: '/img/icons/handdrawn/invitation.svg', alt: 'Invitation', style: 'Handdrawn' },
  { id: 'icon160', src: '/img/icons/handdrawn/jacuzzi.svg', alt: 'Jacuzzi', style: 'Handdrawn' },
  { id: 'icon161', src: '/img/icons/handdrawn/jellyfish.svg', alt: 'Jellyfish', style: 'Handdrawn' },
  { id: 'icon162', src: '/img/icons/handdrawn/key.svg', alt: 'Key', style: 'Handdrawn' },
  { id: 'icon163', src: '/img/icons/handdrawn/letter.svg', alt: 'Letter', style: 'Handdrawn' },
  { id: 'icon164', src: '/img/icons/handdrawn/moka.svg', alt: 'Moka', style: 'Handdrawn' },
  { id: 'icon165', src: '/img/icons/handdrawn/mountain.svg', alt: 'Mountain', style: 'Handdrawn' },
  { id: 'icon166', src: '/img/icons/handdrawn/mountain1.svg', alt: 'Mountain1', style: 'Handdrawn' },
  { id: 'icon167', src: '/img/icons/handdrawn/mouse-clicker.svg', alt: 'Mouse Clicker', style: 'Handdrawn' },
  { id: 'icon168', src: '/img/icons/handdrawn/night.svg', alt: 'Night', style: 'Handdrawn' },
  { id: 'icon169', src: '/img/icons/handdrawn/palm.svg', alt: 'Palm', style: 'Handdrawn' },
  { id: 'icon170', src: '/img/icons/handdrawn/paper-plane.svg', alt: 'Paper Plane', style: 'Handdrawn' },
  { id: 'icon171', src: '/img/icons/handdrawn/park.svg', alt: 'Park', style: 'Handdrawn' },
  { id: 'icon172', src: '/img/icons/handdrawn/pig.svg', alt: 'Pig', style: 'Handdrawn' },
  { id: 'icon173', src: '/img/icons/handdrawn/pin.svg', alt: 'Pin', style: 'Handdrawn' },
  { id: 'icon174', src: '/img/icons/handdrawn/placeholder.svg', alt: 'Placeholder', style: 'Handdrawn' },
  { id: 'icon175', src: '/img/icons/handdrawn/pool.svg', alt: 'Pool', style: 'Handdrawn' },
  { id: 'icon176', src: '/img/icons/handdrawn/pop-up.svg', alt: 'Pop Up', style: 'Handdrawn' },
  { id: 'icon177', src: '/img/icons/handdrawn/pot.svg', alt: 'Pot', style: 'Handdrawn' },
  { id: 'icon178', src: '/img/icons/handdrawn/pull-up.svg', alt: 'Pull Up', style: 'Handdrawn' },
  { id: 'icon179', src: '/img/icons/handdrawn/push-pin.svg', alt: 'Push Pin', style: 'Handdrawn' },
  { id: 'icon180', src: '/img/icons/handdrawn/reward.svg', alt: 'Reward', style: 'Handdrawn' },
  { id: 'icon181', src: '/img/icons/handdrawn/running.svg', alt: 'Running', style: 'Handdrawn' },
  { id: 'icon182', src: '/img/icons/handdrawn/sea.svg', alt: 'Sea', style: 'Handdrawn' },
  { id: 'icon183', src: '/img/icons/handdrawn/sea2.svg', alt: 'Sea2', style: 'Handdrawn' },
  { id: 'icon184', src: '/img/icons/handdrawn/shell.svg', alt: 'Shell', style: 'Handdrawn' },
  { id: 'icon185', src: '/img/icons/handdrawn/sketchbook.svg', alt: 'Sketchbook', style: 'Handdrawn' },
  { id: 'icon186', src: '/img/icons/handdrawn/squash.svg', alt: 'Squash', style: 'Handdrawn' },
  { id: 'icon187', src: '/img/icons/handdrawn/star.svg', alt: 'Star', style: 'Handdrawn' },
  { id: 'icon188', src: '/img/icons/handdrawn/teapot.svg', alt: 'Teapot', style: 'Handdrawn' },
  { id: 'icon189', src: '/img/icons/handdrawn/telephone.svg', alt: 'Telephone', style: 'Handdrawn' },
  { id: 'icon190', src: '/img/icons/handdrawn/toilet-paper.svg', alt: 'Toilet Paper', style: 'Handdrawn' },
  { id: 'icon191', src: '/img/icons/handdrawn/towel.svg', alt: 'Towel', style: 'Handdrawn' },
  { id: 'icon192', src: '/img/icons/handdrawn/trophy.svg', alt: 'Trophy', style: 'Handdrawn' },
  { id: 'icon193', src: '/img/icons/handdrawn/video.svg', alt: 'Video', style: 'Handdrawn' },
  { id: 'icon194', src: '/img/icons/handdrawn/yoga.svg', alt: 'Yoga', style: 'Handdrawn' },

  // ... (continue with any additional icons)
];

const IconPicker = ({ onSelect, defaultFilter = '' }) => {
    const [selectedIconId, setSelectedIconId] = useState('');
    const [filter, setFilter] = useState(defaultFilter);
  
    // Filterlogik
    const filteredIcons = filter
      ? iconData.filter(icon => icon.style === filter)
      : iconData; // Alle Icons anzeigen (nur noch Handdrawn vorhanden)
  
    // Extrahieren Sie einzigartige Stile für die Filterbuttons
    const styles = [...new Set(iconData.map(icon => icon.style))];
  
    // Funktion zum Toggle der Auswahl eines Icons
    const toggleSelectIcon = (icon) => {
      if (selectedIconId === icon.id) {
        // Wenn das ausgewählte Icon erneut angeklickt wird, heben Sie die Auswahl auf
        setSelectedIconId('');
        onSelect(null); // Rufen Sie onSelect mit null auf, um die Auswahl aufzuheben
      } else {
        setSelectedIconId(icon.id);
        // Sofort das Icon auswählen und onSelect aufrufen
        onSelect(icon);
      }
    };
  
    return (
      <div className="iconPicker">
        {/* Stil-Filterleiste */}
        <div className="style-filter-scrollbox">
          {/* Button für "Alle" zuerst */}
          <button onClick={() => setFilter('')} className="style-filter-button">All</button>
  
          {/* Dynamisch generierte Stil-Buttons */}
          {styles.map(style => (
            <button key={style} onClick={() => setFilter(style)} className="style-filter-button">
              {style}
            </button>
          ))}
        </div>
  
        {/* Icon-Auswahlcontainer wie zuvor */}
        <div className="icon-picker-container">
          {filteredIcons.map((icon) => (
            <img
              key={icon.id}
              src={icon.src}
              alt={icon.alt}
              onClick={() => toggleSelectIcon(icon)} // Verwenden Sie die Toggle-Funktion
              className={`icon-style ${selectedIconId === icon.id ? 'selected' : ''} ${icon.style === 'Animations' ? 'animation-icon' : ''}`}
            />
          ))}
        </div>
      </div>
    );
  };
  
  export default IconPicker;